import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { DvpsCoreModule } from '../common/dvps-core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { DigitalHubComponent } from '../features/digital-hub/digital-hub.component';

@NgModule({
  declarations: [
    AppComponent,
    DigitalHubComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,

    AppRoutingModule,
    DvpsCoreModule.forRoot(),
],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }//RouterModule.forRoot([])